<template>
    <v-container grid-list-xl>
        <v-row>
            <!-- function cards list START -->
            <v-col
                v-for="func in functionList"
                :key="func.name"
                cols="12"
                sm="6"
                md="4"
                lg="4"
            >
                <trigger-function-card
                    :func="func"
                    :trigger="trigger"
                    :is-selected="selected.name == func.name"
                    @selected="triggerUpdate(func)"
                />
            </v-col>
        </v-row>
        <!-- function cards list END -->
    </v-container>
</template>

<script>
import TriggerService from "./services/TriggerService";
import TriggerFunctionCard from "./Cards/TriggerFunctionCard.vue";

export default {
    components: {
        TriggerFunctionCard
    },
    props: {
        trigger: {},
        selected: {}
    },
    data() {
        return {
            functionList: [],
            currTriggerState: {}
        };
    },
    mounted: function() {
        TriggerService.getFunctionList(this).then(result => {
            this.functionList = result.data.results;
        });
    },
    methods: {
        triggerUpdate(func) {
            this.$emit("selected", func);
        }
    }
};
</script>
